import React, { FC, useEffect, useMemo, useRef } from 'react'
import { columnGrid, ColumnGrid } from './ColumnGrid'
import { RowsGrid } from './RowsGrid'
import { HeadLunchGrid } from './HeadLunchGrid'
import { exportTableToExcel } from '../../../global.d'
import './header-lunch.css'
import ReactTooltip from 'react-tooltip'
import zIndex from '@mui/material/styles/zIndex'

let renderCount = 0;

const LunchGrid: FC<LunchGridProps> = (props) => {


  renderCount++
  //console.log(`Render LunchGrid #: ${renderCount}`);

  const scrollRef = useRef<HTMLDivElement | null>(null)
  if (scrollRef.current) {
    if (!props.expandirMinuta) {
      if (props.moverScroll !== undefined) {
        scrollRef.current.scrollTo({ left: parseInt(props.moverScroll), behavior: "smooth" })
      }
    }
  }

  // ========= NUEVO: helpers para resaltar celdas SIN depender de `color` =========
  // Formato de clave esperado: `${g}-${r}-${c}` (gridIndex - numRow - colId)
  const parseKey = (k: string) => {
    const [g, r, c] = String(k).split('-')
    return { g: Number(g), r: Number(r), cRaw: c, cNum: Number(c) }
  }

  const colIndexById = useMemo<Record<string, number>>(() => {
    const idxById: Record<string, number> = {}
    const cols = props.column ?? []
    for (let idx = 0; idx < cols.length; idx++) {
      const col: any = cols[idx]

      const tryAdd = (val: any) => {
        if (val === undefined || val === null) return
        const str = String(val)
        if (str && idxById[str] === undefined) {
          idxById[str] = idx
        }
        const num = Number(str)
        if (!Number.isNaN(num)) {
          const numKey = String(num)
          if (idxById[numKey] === undefined) {
            idxById[numKey] = idx
          }
        }
      }

      tryAdd(col?.id)
      tryAdd(col?.colId)
      tryAdd(col?.data?.id)
      tryAdd(col?.data?.colId)

      if (typeof col?.key === 'string') {
        const m = col.key.match(/(\d+)$/)
        if (m) tryAdd(m[1])
      }
    }
    return idxById
  }, [props.column])

  const buildRule = (rowIdx: number, colIdInput: number | string, bg: string, outline: string) => {
    if (!props.tableId) return ''

    const colIdStr = String(colIdInput)
    const colIdNum = Number(colIdInput)

    const scopeSel = `[id="${props.tableId}"]`

    if (props.isMinutaFood) {
      const rowData: any = props.rows?.[rowIdx]
      const hasRecipeField =
        rowData && Object.prototype.hasOwnProperty.call(rowData, `receta${colIdStr}`)
      if (!hasRecipeField) return ''

      const cellSel = `#receta_${rowIdx}_${colIdStr}`
      return `${scopeSel} ${cellSel}{
    background-color:${bg} !important;
    border-radius:0px;
  }\n`
    }

    let colIdx = colIndexById[colIdStr]
    if (colIdx === undefined && !Number.isNaN(colIdNum)) {
      colIdx = colIndexById[String(colIdNum)]
    }
    if (colIdx === undefined) {
      const cols = props.column ?? []
      const targetKey = 'receta' + colIdStr
      for (let i = 0; i < cols.length; i++) {
        const c: any = cols[i]
        const sameId = String(c?.id ?? '') === colIdStr
        const sameKey = String(c?.key || '') === targetKey
        const endsWithId = typeof c?.key === 'string' && c.key.endsWith(colIdStr)
        if (sameId || sameKey || endsWithId) {
          colIdx = i
          break
        }
      }
    }
    if (colIdx === undefined) return ''

    const rowNth = rowIdx + 1
    const colNth = (colIdx as number) + 1
    return `${scopeSel} tbody tr:nth-child(${rowNth}) td:nth-child(${colNth}){
    background-color:${bg} !important;
    border-radius:0px;
  }\n`
  }

  // CSS dinámico para el primer clic (amarillo) y los confirmados (azul)
  const highlightCSS = useMemo(() => {
    let css = ''
    const gIdx = props.gridIndex

    // Primero: celda origen (amarillo)
    if (props.firstHighlightKey) {
      const { g, r, cRaw, cNum } = parseKey(props.firstHighlightKey)
      if (gIdx === undefined || g === Number(gIdx)) {
        css += buildRule(
          r,
          Number.isNaN(cNum) ? cRaw : cNum,
          'rgba(255,235,59,0.65)',
          '#FBC02D'
        ) // amarillo
      }
    }

    // Luego: celdas ya en intercambio (azul)
    // Luego: celdas ya en intercambio (azul fijo igual al vertical)
    ;(props.highlightKeys ?? []).forEach(k => {
      const { g, r, cRaw, cNum } = parseKey(k)
      if (gIdx === undefined || g === Number(gIdx)) {
        const ENROQUE_BLUE = '#7EACF7'        // ← azul usado en MinutaVertical
        css += buildRule(
          r,
          Number.isNaN(cNum) ? cRaw : cNum,
          ENROQUE_BLUE,
          ENROQUE_BLUE
        )
      }
    })


    return css
  }, [
    props.firstHighlightKey,
    props.highlightKeys,
    props.gridIndex,
    props.tableId,
    props.rows,
    props.isMinutaFood,
    colIndexById,
  ])

  // ============================================================================
  try {
    return (
      <div className='card-xxl-stretch mb-5 mb-xl-10'>
        {/* begin::arrow table */}
        {props.isHeader ? (
          <HeadLunchGrid
            information={props.information}
            openDetalle={props.openDetalle}
            isMinutaFood={props.isMinutaFood}
            onNewTemplate={props.onNewTemplate}
            onSaveSend={props.onSaveSend}
            showSave={props.showSave}
            showSaveSend={props.showSaveSend}
            onSave={props.onSave}
            newTemplate={props.newTemplate}
            textNewTemplate={props.textNewTemplate}
            replyAll={props.replyAll}
            resumeDetalle={props.resumeDetalle}
            undo={props.undo}
            undoAll={props.undoAll}
            onExportClient={props.onExportClient}
            onExportClient2={props.onExportClient2}
            showLeyend={props.showLeyend}
            onEdit={props.onEdit}
            normal={props.normal}
            getNormal={props.getNormal}
            getIcono={props.getIcono}
            getColor={props.getColor}
            getPrecio={props.getPrecio}
            getLeyend={props.getLeyend}
            showShare={props.showShare}
            onShare={props.onShare}
            showValidate={props.showValidate}
            onValidate={props.onValidate}
            showApprove={props.showApprove}
            onApprove={props.onApprove}
            showApproveDetail={props.showApproveDetail}
            onApproveDetail={props.onApproveDetail}
            showDelete={props.showDelete}
            onDelete={props.onDelete}
            onExport={() => {
              if (props.isMinutaVertical && props.onExport) {
                return props.onExport()
              }
              return props.tableId !== undefined ? exportTableToExcel(props.tableId, (props.nameFile || 'Planilla Contrato'), props.totalFormularios || 0) : []
            }}
            showReplicateMinutaFollower={props.showReplicateMinutaFollower}
            onReplicateMinutaFollower={props.onReplicateMinutaFollower}
            showMinuteRedistribution={props.showMinuteRedistribution}
            onMinuteRedistribution={props.onMinuteRedistribution}
            showReplicateMinutaFija={props.showReplicateMinutaFija}
            onReplicateMinutaFija={props.onReplicateMinutaFija}
            showReplicateMinuta={props.showReplicateMinuta}
            onReplicateMinuta={props.onReplicateMinuta}
            showExportIcon={props.showExportIcon}
            showExportClientIcon={props.showExportClientIcon}
            showExportClientIcon2={props.showExportClientIcon2}
            showPrintIcon={props.showPrintIcon}
            showPrintClientIcon={props.showPrintClientIcon}
            showUndo={props.showUndo}
            showUndoAll={props.showUndoAll}
            showReplyAll={props.showReplyAll}
            showHomologate={props.showHomologate}
            onHomologate={props.onHomologate}
          />
        ) : null}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {(props.isHeader || props.isPagination) && props.column?.length ? (
            // <div className='container-arrows py-2'>
            <div className='container-arrows py-2'>
              <ul>
                <li className='bi bi-arrow-left-short icon-arrow left-table'
                  data-tip
                  data-for='back'
                  onClick={props.back}></li>
                <ReactTooltip id='back' place='right' type='info' effect='solid'>
                  Día
                </ReactTooltip>
                <li className='bi bi-arrow-left-square icon-arrow left-table'
                  data-tip
                  data-for='back-week'
                  onClick={props.backWeek}></li>
                <ReactTooltip id='back-week' place='right' type='info' effect='solid'>
                  Semana
                </ReactTooltip>
                <li className='bi bi-arrow-left-square-fill icon-arrow left-table'
                  data-tip
                  data-for='back-all'
                  onClick={props.backAll}></li>
                <ReactTooltip id='back-all' place='right' type='info' effect='solid'>
                  Inicio
                </ReactTooltip>
              </ul>
            </div>
          ) : null}
          {/* end::arrow table */}
          {/* begin::Table container */}
          <div className='table-responsive' id="container-table" ref={scrollRef}>
            {/* begin::Table */}
            {props.showExportIcon && props.tableId && props.nameFile ?
              <i className="bi bi-file-earmark-arrow-down" onClick={() => { return props.tableId !== undefined ? exportTableToExcel(props.tableId, (props.nameFile || 'Planilla Contrato'), props.totalFormularios || 0) : [] }}></i> : null
            }
            <div className='container-father' style={{ display: "flex", maxHeight: "600px", width: "auto" }}>
              {props.rowFather?.length ?
                <table id="" className='table table-row-bordered tabla-menu-lateral table-row-gray-100 align-middle gs-0 gy-3'
                  style={{ position: "sticky", left: 0, zIndex: "1" }}
                >
                  <thead>
                    <tr style={{ position: "sticky", top: "0" }}>
                      <th className="th-table clase-2" scope="" >
                        <button type="button" className="btn btn-link">Estructura Padre</button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.rowFather?.map((item: any, i: number) => {
                      return <tr key={i}>
                        <td className='clase-row-1 clase-row-2 clase-row-padre '
                          style={{ backgroundColor: item.colorGrupoEstructura, height: "calc(41.1px)" }}>
                          <a href='#' className='text-dark fw-bolder text-hover-primary d-inline22'>
                            <span className="" data-mui-internal-clone-element="true">{item?.text}</span>
                          </a>
                        </td>
                      </tr>
                    })}
                  </tbody>
                </table> : <></>
              }
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 table-minuta' id={props.tableId}

              >
                {/* ========= NUEVO: estilos dinámicos para resaltar celdas ========= */}
                {Boolean(highlightCSS) && (
                  <style dangerouslySetInnerHTML={{ __html: highlightCSS }} />
                )}
                {/* ========= NUEVO: estilos dinámicos para resaltar celdas ========= */}
                {Boolean(highlightCSS) && (
                  <style dangerouslySetInnerHTML={{ __html: highlightCSS }} />
                )}
                {/* begin::Table head */}
                <ColumnGrid
                  column={props.column}
                  isCheckbox={props.isCheckbox}
                  isHeader={props.isHeader}
                  isMinutaVertical={props.isMinutaVertical}
                  isMinutaHorizontal={props.isMinutaHorizontal}
                />
                {/* end::Table head */}
                {/* begin::Table body */}
                <RowsGrid
                  colorSelected={props.colorSelected}
                  column={props.column}
                  textPonderado={props.textPonderado}
                  blurPonderado={props.blurPonderado}
                  blurComensales={props.blurComensales}
                  refreshData={props.refreshData}
                  rows={props.rows}
                  isCheckbox={props.isCheckbox}
                  openModal={props.openModal}
                  isMinutaVertical={props.isMinutaVertical}
                  isMinutaFood={props.isMinutaFood}
                  color={props.color}
                  icono={props.icono}
                  normal={props.normal}
                  precio={props.precio}
                  allColumn={props.allColumn}
                  clearedSwapCoords={props.clearedSwapCoords}
                />
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
          {(props.isHeader || props.isPagination) && props.column?.length ? (
            <div className='container-arrows'>
              <ul>
                <li
                  className='bi bi-arrow-right-short icon-arrow right-table'
                  data-tip
                  data-for='next'
                  onClick={props.next}
                ></li>
                <ReactTooltip id='next' place='left' type='info' effect='solid'>
                  Día
                </ReactTooltip>
                <li
                  className='bi bi-arrow-right-square icon-arrow right-table'
                  data-tip
                  data-for='next-week'
                  onClick={props.nextWeek}></li>
                <ReactTooltip id='next-week' place='left' type='info' effect='solid'>
                  Semana
                </ReactTooltip>
                <li
                  className='bi bi-arrow-right-square-fill icon-arrow right-table'
                  data-tip
                  data-for='next-all' onClick={props.nextAll}></li>
                <ReactTooltip id='next-all' place='left' type='info' effect='solid'>
                  Final
                </ReactTooltip>
              </ul>
            </div>
          ) : null}
        </div>
        {/* begin::Body */}
      </div>
    )
  } catch (error) {
    console.log(error);
    return <></>
  }
}
export interface LunchGridProps {
  
  moverScroll?: string
  expandirMinuta?: boolean
  tableId?: string
  nameFile?: string
  title?: string
  column?: columnGrid[]
  isMinutaVertical?: boolean
  isMinutaHorizontal?: boolean
  isMinutaFood?: boolean
  isHeader?: boolean
  columnInicial?: columnGrid[]
  totalFormularios?: number
  rows?: any
  rowFather?: any[]
  isCheckbox?: boolean
  openModal?(row: any, colum: any, num: number): void
  textFilter?: string
  maxColumn?: number
  back?(): void
  next?(): void
  backWeek?(): void
  nextWeek?(): void
  backAll?(): void
  nextAll?(): void
  openDetalle?(): void
  onSaveSend?(): void
  resumeDetalle?(): void
  getColor?(): void
  getIcono?(): void
  getNormal?(): void
  getPrecio?(): void
  onEdit?(): void
  getLeyend?(): void
  undo?(): void
  undoAll?(): void
  replyAll?(): void
  onSave?(): void
  onNewTemplate?(): void
  blurPonderado?(event: React.FocusEvent<HTMLInputElement, Element>, row: any, column: any, idRow: number, idColum: number, rowItem?: any, edit?: boolean): void
  blurComensales?(event: React.FocusEvent<HTMLInputElement, Element>, row: any, column: any, idRow: number, idColum: number, rowItem?: any, edit?: boolean): void
  refreshData?(reload?: boolean): void
  onExport?(): void
  onExportClient?(): void
  onExportClient2?(): void
  isPagination?: boolean
  precio?: boolean
  color?: boolean
  icono?: boolean
  normal?: boolean
  textPdf?: string
  textPdfClient?: string
  textExcel?: string
  textExcelClient?: string
  colorSelected?: string[]
  clearedSwapCoords?: string[]
  textBack?: string
  textBackAll?: string
  showSave?: boolean,
  showSaveSend?: boolean,
  textSave?: string
  textSaveSend?: string
  showLeyend?: boolean
  newTemplate?: boolean,
  textNewTemplate?: string,
  information?(): void,
  showShare?: boolean,
  onShare?(): void,
  showValidate?: boolean,
  onValidate?(): void,
  showApprove?: boolean,
  onApprove?(): void,
  showApproveDetail?: boolean,
  onApproveDetail?(): void,
  showDelete?: boolean,
  createMinute?: boolean,
  onCreateMinute?(): void,
  onDelete?(): void,
  textPonderado?: boolean,
  showReplicateMinutaFollower?: boolean,
  onReplicateMinutaFollower?(): void,
  showMinuteRedistribution?: boolean,
  onMinuteRedistribution?(): void,
  showReplicateMinutaFija?: boolean,
  showReplicateMinuta?: boolean,
  onReplicateMinutaFija?(): void,
  onReplicateMinuta?(): void,
  exportExternal?: boolean,
  onExportExternal?(val: any): void,
  showExportIcon?: boolean,
  showExportClientIcon?: boolean,
  showExportClientIcon2?: boolean,
  showPrintIcon?: boolean,
  showPrintClientIcon?: boolean,
  showUndo?: boolean,
  showUndoAll?: boolean,
  showReplyAll?: boolean,
  showHomologate?: boolean,
  onHomologate?(val: any): void,
  allColumn?: any

  // ======== NUEVAS PROPS para resaltar celdas (NO dependen de `color`) ========
  gridIndex?: number
  /** clave del primer clic (pinta AMARILLO). Formato: `${gridIndex}-${numRow}-${idColumn}` */
  firstHighlightKey?: string | null
  /** claves a resaltar en AZUL (parejas ya intercambiadas). Mismo formato de clave. */
  highlightKeys?: string[]
}

LunchGrid.defaultProps = {
  moverScroll: "0",
  expandirMinuta: false,
  isCheckbox: false,
  rowFather: [],
  isMinutaVertical: false,
  isHeader: true,
  columnInicial: [],
  column: [],
  rows: [],
  maxColumn: 7,
  showLeyend: true,
  newTemplate: false,
  showShare: false,
  showValidate: false,
  textPonderado: false,
  exportExternal: false,
  showSave: true,
  showSaveSend: true,
  showExportIcon: true,
  showExportClientIcon: true,
  showExportClientIcon2: true,
  showPrintIcon: true,
  showPrintClientIcon: true,
  showUndo: true,
  showUndoAll: true,
  showReplyAll: true,
  showHomologate: false,
}
export { LunchGrid }
